import { IApplicationState } from '../../types/redux';

export const getPageNewbuildingBroker = (state: IApplicationState) => {
  return state.offersData.newbuildingBroker;
};
